export enum ClientDetailSection {
  PrimaryInfo = 'primary',
  AdditionalInfo = 'additional',
}
